
import { SimpleBanner } from './banners/SimpleBanner';
import { StripeOfferBanner } from './banners/StripeOfferBanner';
import { Mode, NormalizeMode } from './types';

export const PAYMENT_API_ENDPOINT = import.meta.env.VITE_PAYMENT_API_ENDPOINT;

export const defaultMode: NormalizeMode = {
  relativeDate: null,
  dateStart: null,
  dateEnd: null,
  upperBlock: null,
  buttonBlock: {
    yearButton: {
      title: 'Buy for a year',
      subText: '$7.49/month',
      chevronText: 'Save 42%',
      payUrl: `${PAYMENT_API_ENDPOINT}/stripe/create-checkout-session?plan=year`
    },
    monthButton: {
      title: 'Buy for a month',
      subText: '$12.99/month',
      payUrl: `${PAYMENT_API_ENDPOINT}/stripe/create-checkout-session?plan=month`
    }
  },
  banner: {
    showBanner: false,
    showTimer: false,
    titleText: null,
    bannerComponent: SimpleBanner
  }
};

const DECEMBER_INDEX = 11;
const JANUARY_INDEX = 0;

const stripeOfferMode: Mode = {
  relativeDate: () => new Date(Date.now()),
  dateStart: () => new Date(Date.UTC(2024, DECEMBER_INDEX, 21, 0, 0, 0)),
  dateEnd: () => new Date(Date.UTC(2026, JANUARY_INDEX, 2, 8, 0, 0)),
  upperBlock: null,
  buttonBlock: {
    yearButton: {
      title: 'Buy for a year',
      subText: '$89.99 ($7.49/month)',
      chevronText: 'Save 42%',
      payUrl: `${PAYMENT_API_ENDPOINT}/stripe/create-checkout-session?plan=year`
    },
    upgradeButton: {
      title: 'Upgrade for a year',
      subText: '$59.99 ($6/month)',
      payUrl: '',
      chevronText: 'Save 54%'
    },
    monthButton: {
      title: 'Buy for a month',
      subText: '$12.99/month',
      payUrl: `${PAYMENT_API_ENDPOINT}/stripe/create-checkout-session?plan=month`
    },
    trialTestButton: {
      title: 'Test month trial',
      subText: '$0.02/month',
      payUrl: `${PAYMENT_API_ENDPOINT}/stripe/create-checkout-session?plan=month`
    }
  },
  banner: {
    showBanner: true,
    showTimer: false,
    titleText: null,
    bannerComponent: StripeOfferBanner
  }
};

export const modes: Mode[] = [stripeOfferMode];
